<div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="data.isFunctionnalError">
  <mp-functionnal-error-label [error]="data.errorKey" [variable]="variable"></mp-functionnal-error-label>
  <button (click)="mpSnackbarRef.dismiss()">{{ 'API.OK' | translate }}</button>
</div>

<div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="!data.isFunctionnalError">
  <span>{{ 'API.UNKNOWN_ERROR' | translate }}</span>
</div>
